import { render, staticRenderFns } from "./Carousel3dEffect.vue?vue&type=template&id=38242f96&scoped=true&"
import script from "./Carousel3dEffect.vue?vue&type=script&lang=js&"
export * from "./Carousel3dEffect.vue?vue&type=script&lang=js&"
import style0 from "./Carousel3dEffect.vue?vue&type=style&index=0&id=38242f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38242f96",
  null
  
)

export default component.exports